define('v3/Pages/WayOfWork/Components/WowProgressBar/WowProgressBar.Component',[
	'knockout',
	'text!v3/Pages/WayOfWork/Components/WowProgressBar/WowProgressBar.Component.html'
], function (ko, htmlString) {
	function validateParams (params) {
		if (!ko.isObservable(params.stage)) {
			throw new Error('params.stage is not observable.');
		}
	}

	function WowProgressBarViewModel (params) {
		var self = this;

		validateParams(params);

		self.stage = params.stage;

		var progress = [15, 70, 140, 165];
		var visualProgress = [25, 50, 75, 100];
		var visualProgressNoWowFour = [33.3, 66.7, 100];

		self.isTableToggleable = ko.unwrap(params.isTableToggleable);
		self.isTableVisible = ko.observable(ko.unwrap(params.isTableVisible));
		self.isLearningResultVisible = ko.unwrap(params.isLearningResultVisible);

		self.tableToggle = function () {
			self.isTableVisible(!self.isTableVisible());
		};

		self.learningResult = ko.computed(function () {
			return self.stage() ? progress[self.stage() - 1] : 0;
		});

		self.progressBarWidth = ko.computed(function () {
			if (self.stage()) {
				var index = self.stage() - 1;
				if (Settings.isWayOfWorkMethodFourEnabled) {
					return visualProgress[index];
				} else {
					return visualProgressNoWowFour[index];
				}
			} else {
				return 0;
			}
		});

		self.extraCss = !Settings.isWayOfWorkMethodFourEnabled ? 'disable-wow4' : '';
	}

	return { viewModel: WowProgressBarViewModel, template: htmlString };
});

